import { Viewer3dRelatedPreviewObject } from '@3ddv/dvm-internal';
import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatedPreviewsService {
  public currentPreview: WritableSignal<Viewer3dRelatedPreviewObject | null> = signal(null);

  public resetCurrentPreview(): void {
    this.currentPreview.set(null);
  }
}
